var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenUploadMusicLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 5.66699H15.3449C15.002 4.33874 14.2933 3.13331 13.2995 2.18769C12.3057 1.24206 11.0666 0.594151 9.72295 0.317579C8.37931 0.0410064 6.98503 0.146862 5.69854 0.623118C4.41205 1.09937 3.28494 1.92693 2.44529 3.01176C1.60563 4.09659 1.0871 5.39518 0.948603 6.75998C0.810111 8.12479 1.05721 9.50107 1.66183 10.7325C2.26645 11.9638 3.20435 13.0009 4.36894 13.7259C5.53353 14.4509 6.87813 14.8347 8.24994 14.8337H16.4999C17.7155 14.8337 18.8813 14.3508 19.7408 13.4912C20.6004 12.6317 21.0833 11.4659 21.0833 10.2503C21.0833 9.03475 20.6004 7.86896 19.7408 7.00942C18.8813 6.14988 17.7155 5.66699 16.4999 5.66699Z",
    fill: "#CCDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenUploadMusicLogo);
export default __webpack_public_path__ + "static/media/OpenUploadMusicLogo.a8443e50cc29ed7b8832f85c93b2351a.svg";
export { ForwardRef as ReactComponent };